module.exports = __webpack_public_path__ + "static/media/lewy-dol-geo.63b10cf7.svg";